import type { DataTableDesignTokens } from '@primeuix/themes/types/datatable';

/**
 * DataTable (Table) component tokens
 *
 * Custom styling for PrimeNG Table component to create a clean, modern appearance
 * with improved spacing, borders, and hover states.
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/datatable/index.ts
 *
 * Component documentation:
 * https://primeng.org/table
 */
export const datatableComponentTokens: Partial<DataTableDesignTokens> = {
  root: {
    transitionDuration: '{transition.duration}',
    borderColor: '{border.main}',
  },
  header: {
    background: '{surface.100}',
    borderColor: '{border.main}',
    color: '{text.color}',
    borderWidth: '0 0 2px 0',
    padding: '0.75rem',
  },
  headerCell: {
    background: '{surface.100}',
    hoverBackground: '{surface.200}',
    selectedBackground: '{surface.100}',
    borderColor: '{border.main}',
    color: '{text.color}',
    padding: '0.75rem',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
  },
  columnTitle: {
    fontWeight: '600',
  },
  row: {
    background: '{surface.0}',
    hoverBackground: '{surface.50}',
    selectedBackground: '{primary.50}',
    stripedBackground: '{surface.50}',
    color: '{text.color}',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
  },
  bodyCell: {
    borderColor: '{border.main}',
    padding: '0.75rem 1rem',
    selectedBorderColor: '{primary.color}',
  },
  footer: {
    background: '{surface.0}',
    borderColor: '{border.main}',
    color: '{text.color}',
    borderWidth: '1px 0 0 0',
    padding: '1rem',
  },
  footerCell: {
    background: '{surface.0}',
    borderColor: '{border.main}',
    color: '{text.color}',
    padding: '1rem',
  },
  columnFooter: {
    fontWeight: '600',
  },
  resizeIndicator: {
    color: '{primary.color}',
  },
  sortIcon: {
    color: '{text.muted}',
    hoverColor: '{primary.color}',
    size: '0.875rem',
  },
  loadingIcon: {
    size: '2rem',
  },
  paginatorTop: {
    borderColor: '{border.main}',
    borderWidth: '0 0 1px 0',
  },
  paginatorBottom: {
    borderColor: '{border.main}',
    borderWidth: '1px 0 0 0',
  },
};
